/**
 * Created by dmccleod on 2/15/17.
 */
/*
 File: share-widget.js
 Author: D McCleod
 Created: 2/15/2017
 Modified: 4/14/2022
 Description: toggle visibility of share widget
 */


const shareLink = $('#social-share-link');
const shareWidget = $('#social-share-widget');
const closeShare = $('#close-share-widget');

var socialClassMap = {
    '.social--facebook': 'fburl',
    '.social--twitter': 'twiturl',
    '.social--linkedin': 'linkedinurl',
    '.social--whatsapp': 'whatsappurl'
};

function addSocialHander() {
    for (var i in socialClassMap) {
        $(i)
            .attr('data-social', socialClassMap[i])
            .bind('click', window[ $(i).data('social') ] );
    }
}

function initShareWidget() {
	if (typeof isMscpApp !== undefined && isMscpApp) {
		shareWidget.remove();
		$('.crs-footer_social').remove();
    } else {
        $(document).on('mouseenter touchstart', '#social-share-link', function() {
			$('.menu-item--social').addClass('active');
		});

		$(document).on('mouseleave', '.crs-utils, .menu-item--social', function() {
			$('.menu-item--social').removeClass('active');
		});
		$(document).on('mouseenter touchstart', '.crs-footer_share', function() {
			$('.crs-footer_list').addClass('active');
		});

		$(document).on('mouseleave', '.crs-footer_social, .crs-footer_list', function() {
			$('.crs-footer_list').removeClass('active');
		});
		addSocialHander();
    }
}


export { initShareWidget };

